import React from 'react';
import Caption from '../Caption';

// image grid uses image tags
// first -- url for image
// style -- for color theme
const VideoMockup = ({video, caption}) => (
  <section>
    <div className="portfolio-img">
      <video muted="true" loop="true" autoplay="true" playsinline="true">
        <source src={video} type="video/mp4"/>
      </video>
    </div>
    {caption !== undefined ? <Caption captionText={caption}/> : null }
  </section>

);

export default VideoMockup;



// WEBPACK FOOTER //
// ./src/layout/portfolio/VideoMockup.js